import * as React from 'react';

function SvgEditMobile(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12.815} height={14.631} {...props}>
      <defs>
        <clipPath id="edit_mobile_svg__prefix__clip-path">
          <path
            id="edit_mobile_svg__prefix__Clip_2"
            d="M0 0h12.815v14.631H0z"
            className="edit_mobile_svg__prefix__cls-1"
            data-name="Clip 2"
          />
        </clipPath>
        <style>{'.edit_mobile_svg__prefix__cls-1{fill:#008afd}'}</style>
      </defs>
      <g id="edit_mobile_svg__prefix__edit_mobile">
        <path
          id="edit_mobile_svg__prefix__Clip_2-2"
          fill="none"
          d="M0 0h12.815v14.631H0z"
          data-name="Clip 2"
        />
        <g
          id="edit_mobile_svg__prefix__Group_3"
          clipPath="url(#edit_mobile_svg__prefix__clip-path)"
          data-name="Group 3"
        >
          <path
            id="edit_mobile_svg__prefix__Fill_1"
            d="M.463 14.631a.464.464 0 01-.354-.166.454.454 0 01-.1-.374l.544-3.237 3.091 2.594L.629 14.6a.465.465 0 01-.166.031zm4.383-1.846L.971 9.535l6-7.147 3.875 3.251-6 7.146zm6.82-8.127l-3.875-3.25L8.832.166a.465.465 0 01.653-.058l3.165 2.657a.463.463 0 01.057.653l-1.041 1.24z"
            className="edit_mobile_svg__prefix__cls-1"
            data-name="Fill 1"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgEditMobile;
